import { Marca } from '../../types';
import { EvaChatConfig, GetEvaChatConfigParams } from './chat-bot-eva-source.types';

const SCRT2_URL = 'https://yduqs2020.my.salesforce-scrt.com';

const makeEvaConfig = (marca: Marca, deploymentName: string, baseUrl: string, bootstrapUrl: string): EvaChatConfig => ({
  marca,
  ambientes: ['local', 'dev', 'prd', 'hml'],
  orgId: '00D5e000000K9Bl',
  deploymentName,
  baseUrl,
  bootstrapUrl,
  scrt2URL: SCRT2_URL,
});

export const evaChatConfigs: EvaChatConfig[] = [
  makeEvaConfig(
    'estacio',
    'Chat_MIAW_Estacio',
    'https://yduqs2020.my.site.com/ESWChatMIAWEstacio1741713642969',
    'https://yduqs2020.my.site.com/ESWChatMIAWEstacio1741713642969/assets/js/bootstrap.min.js',
  ),
  makeEvaConfig(
    'ibmec',
    'Chat_MIAW_Ibmec',
    'https://yduqs2020.my.site.com/ESWChatMIAWIbmec1741786692264',
    'https://yduqs2020.my.site.com/ESWChatMIAWIbmec1741786692264/assets/js/bootstrap.min.js',
  ),
  makeEvaConfig(
    'idomed',
    'Chat_MIAW_Idomed',
    'https://yduqs2020.my.site.com/ESWChatMIAWIdomed1741787412721',
    'https://yduqs2020.my.site.com/ESWChatMIAWIdomed1741787412721/assets/js/bootstrap.min.js',
  ),
  makeEvaConfig(
    'wyden',
    'Chat_MIAW_Wyden',
    'https://yduqs2020.my.site.com/ESWChatMIAWWyden1741788497456',
    'https://yduqs2020.my.site.com/ESWChatMIAWWyden1741788497456/assets/js/bootstrap.min.js',
  ),
];

export const getEvaChatConfig = ({ ambiente, marca }: GetEvaChatConfigParams) =>
  evaChatConfigs.find((config) => config.marca === marca && config.ambientes.includes(ambiente));
